module.exports = __webpack_public_path__ + "img/windows-x-desktop-1.344d8c4b.png";